import React from "react";
import { useLocation, Link } from "react-router-dom";
import { MdArrowLeft, MdArrowRight } from "react-icons/md";
import { RiDashboardFill } from "react-icons/ri";
import { motion } from "framer-motion";
import { useSelector } from "react-redux";
import { arClass } from "../../utils/useArClass";
import Txt from "../Text";
import textTranslator from "../../utils/useTextTranslator";
import { de } from "zod/v4/locales";



const Text = ({ children, className }) => {
  return (
    <Txt page="BREADCRUMBS" className={className} keyName="BREADCRUMBS">
      {children}
    </Txt>
  );
};

export default function Breadcrumbs({ unactive }) {
  const darkMode = useSelector((state) => state.settings.darkMode) || false;
  const defaultLanguage = useSelector((state) => state.settings.defaultLanguage);
  const location = useLocation();
  const currentPath = location.pathname;

  const generateBreadcrumbs = () => {
    const breadcrumbs = [
      {
        label:"Dashboard",
        url: "/dashboard",
        icon: <RiDashboardFill />,
      },
    ];

    const pathSegments = currentPath.split("/").filter(Boolean);
    let accumulatedPath = "";

    pathSegments.forEach((segment, index) => {
      accumulatedPath += `/${segment}`;
      const isLast = index === pathSegments.length - 1;
      const formattedLabel = segment
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

      breadcrumbs.push({
        label: formattedLabel,
        url: isLast ? null : accumulatedPath,
        isLast,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();



  return (
    <motion.div
      className={arClass(`w-full mb-4 rounded-xl shadow-sm flex items-center overflow-x-auto scrollbar-hide transition-all duration-300 `)}
      initial={{ opacity: 0, y: -8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <div className={arClass(`w-full px-4 py-3 mx-3 rounded-lg max-sm:rounded-md ${
        darkMode ? "bg-[#1f2937] text-gray-100" : "bg-white text-gray-800"
      }`)}>
        <nav aria-label="breadcrumb" className={arClass("flex items-center w-full ")}>
        <ol className={arClass("flex items-center gap-2 flex-wrap text-sm font-medium")}>
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            const isActive = isLast && !unactive;

            return (
              <React.Fragment key={index}>
                <Link
                  to={crumb.url || "#"}
                  className={arClass(`flex items-center gap-1 px-2 py-1.5 rounded-md transition-all duration-200 max-sm:text-xs ${
                    isActive
                      ? darkMode
                        ? "bg-blue-900/30 !text-blue-900 "
                        : "bg-blue-300/20 !text-blue-900 "
                      : darkMode
                      ? "hover:bg-gray-700 !text-blue-900"
                      : "hover:bg-gray-100 !text-blue-900"
                  } ${unactive ? "opacity-60 pointer-events-none" : ""}`)}
                >
                  {crumb.icon && (
                    <span className={arClass("text-base flex items-center max-sm:text-xs")}>
                      {crumb.icon}
                    </span>
                  )}
                  <span className={arClass("whitespace-nowrap max-sm:text-xs")}>
                    {
                     ( parseInt(crumb.label) || parseFloat(crumb.label)) ? crumb.label : <Text>{crumb.label.toLocaleLowerCase()}</Text>
                    }
                    
                  </span>
                </Link>

                {!isLast && !unactive && (
                  defaultLanguage === "ar" ? (
                    <MdArrowLeft className={arClass("text-lg max-sm:text-sm")} />
                  ) : (
                    <MdArrowRight className={arClass("text-lg max-sm:text-sm")} />
                  )
                )}
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
      </div>
    </motion.div>
  );
}
